import { EditorSDK } from '@wix/platform-editor-sdk';
import { EditorScriptApi } from '../../../api/api';
import { BaseAddPage } from './base-add-page';
import {
  installEcomPlatform,
  addComponents,
  EcomComponent,
} from '@wix/ecom-platform-sdk';
import {
  isEcomCheckoutInstalled,
  isEcomInstalled,
  isEcomThankYouPageInstalled,
} from '../../editor-sdk-actions';

export class AddEcomPages extends BaseAddPage {
  private ecomInstalled: any;
  private ecomCheckoutInstalled: boolean;
  private ecomThankYouPageInstalled: boolean;
  constructor(
    protected editorSDK: EditorSDK,
    protected appToken,
    protected instance,
    private editorScriptApi: EditorScriptApi,
  ) {
    super(editorSDK, appToken, instance);
  }

  public async shouldAddPage(): Promise<boolean> {
    const isEditor3 = globalThis.commonConfig?.host === 'EDITOR3';
    this.ecomInstalled = await isEcomInstalled(this.editorSDK);
    this.ecomCheckoutInstalled = await isEcomCheckoutInstalled(this.editorSDK);
    this.ecomThankYouPageInstalled = await isEcomThankYouPageInstalled(
      this.editorSDK,
    );

    if (
      !isEditor3 &&
      (
        !this.ecomInstalled ||
        !this.ecomCheckoutInstalled ||
        !this.ecomThankYouPageInstalled
      )
    ) {
      return true;
    }

    return false;
  }

  public async execute() {
    if (!this.ecomInstalled) {
      await installEcomPlatform(this.editorSDK);
    }

    if (!this.ecomCheckoutInstalled) {
      await addComponents(this.editorSDK, [EcomComponent.CHECKOUT]);
    }

    if (!this.ecomThankYouPageInstalled) {
      await addComponents(this.editorSDK, [EcomComponent.THANK_YOU_PAGE]);
    }
  }

  protected get widgetId() {
    return '';
  }

  public get widgetName() {
    return 'AddEcomPages';
  }

  public get stepTranslate() {
    return 'ecom-page-migration.progress-bar.step-1';
  }
}
